import { render, staticRenderFns } from "./KitInfoCard.vue?vue&type=template&id=60574cd2&scoped=true&"
import script from "./KitInfoCard.vue?vue&type=script&lang=js&"
export * from "./KitInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./KitInfoCard.vue?vue&type=style&index=0&id=60574cd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60574cd2",
  null
  
)

export default component.exports